
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class SmsTemplateVariablesDialog extends Serenity.EntityDialog<SmsTemplateVariablesRow, any> {
        protected getFormKey() { return SmsTemplateVariablesForm.formKey; }
        protected getIdProperty() { return SmsTemplateVariablesRow.idProperty; }
        protected getLocalTextPrefix() { return SmsTemplateVariablesRow.localTextPrefix; }
        protected getNameProperty() { return SmsTemplateVariablesRow.nameProperty; }
        protected getService() { return SmsTemplateVariablesService.baseUrl; }
        protected getDeletePermission() { return SmsTemplateVariablesRow.deletePermission; }
        protected getInsertPermission() { return SmsTemplateVariablesRow.insertPermission; }
        protected getUpdatePermission() { return SmsTemplateVariablesRow.updatePermission; }

        protected form = new SmsTemplateVariablesForm(this.idPrefix);

    }
}